import React, { useState } from "react";
import { FiLock } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { Spinner } from "../Components/Components";

import SAFM from "../libs/Safm";

const Otp = () => {
  const [loading, setLoading] = useState(false);
  const [otpError, setOtpError] = useState(null);
  const navigate = useNavigate();

  const onChangeFieldValue = (e) => {
    const { target } = e;

    let id = parseInt(target.id.replace("field", ""));
    const char = target.value.trim();

    if (char.length > 0) {
      if (id < 5) {
        id++;
        document.getElementById(`field${id}`).focus();
      } else {
        target.blur();
        confirmOtpCode();
      }
    } else {
      if (id > 1) {
        id--;
        document.getElementById(`field${id}`).focus();
        document.getElementById(`field${id}`).value = "";
      }
    }
  };

  const confirmOtpCode = async () => {
    setOtpError(null);

    let code = "";
    const fields = document.querySelectorAll("[data-role='field']");
    fields.forEach((field) => {
      code += field.value;
    });

    if (code.length === 5) {
      setLoading(true);

      const { status, message } = await SAFM.checkOtp(code);

      if (status !== "OK") {
        setLoading(false);
        setOtpError(message);
      } else {
        const { nacc, dusr, otp, cellulare } = message;

        let user = JSON.parse(window.localStorage.getItem("user"));
        user = { ...user, nacc, dusr, otp, cellulare };

        window.localStorage.setItem("user", JSON.stringify(user));

        navigate("/home");
      }
    }
  };

  return (
    <div className='bg-white dark:bg-black'>
      <div className='bg-blue-100 h-screen w-full flex flex-col items-center'>
        <div className='w-[400px] bg-white text-black dark:text-white dark:bg-black mt-24 rounded-lg p-9 flex flex-col items-center'>
          <div className='bg-blue-100 border border-dashed border-blue p-6 rounded-full'>
            <FiLock className='text-blue text-[48px]' />
          </div>
          <h3 className='mt-6 text-2xl mb-2'>Codice OTP</h3>
          <span className='text-black-700 text-center dark:text-black-400'>Ti è stato inviato un SMS con il codice di verifica</span>

          <div className='flex my-6'>
            <input
              disabled={loading}
              maxLength={1}
              onKeyUp={onChangeFieldValue}
              className='w-10 h-12 m-2 bg-black-100 dark:bg-black-900 text-2xl text-center rounded-lg'
              id='field1'
              type='text'
              data-role='field'
            />
            <input
              disabled={loading}
              maxLength={1}
              onKeyUp={onChangeFieldValue}
              className='w-10 h-12 m-2 bg-black-100 dark:bg-black-900 text-2xl text-center rounded-lg'
              id='field2'
              type='text'
              data-role='field'
            />
            <input
              disabled={loading}
              maxLength={1}
              onKeyUp={onChangeFieldValue}
              className='w-10 h-12 m-2 bg-black-100 dark:bg-black-900 text-2xl text-center rounded-lg'
              id='field3'
              type='text'
              data-role='field'
            />
            <input
              disabled={loading}
              maxLength={1}
              onKeyUp={onChangeFieldValue}
              className='w-10 h-12 m-2 bg-black-100 dark:bg-black-900 text-2xl text-center rounded-lg'
              id='field4'
              type='text'
              data-role='field'
            />
            <input
              disabled={loading}
              maxLength={1}
              onKeyUp={onChangeFieldValue}
              className='w-10 h-12 m-2 bg-black-100 dark:bg-black-900 text-2xl text-center rounded-lg'
              id='field5'
              type='text'
              data-role='field'
            />
          </div>

          <button
            className='flex items-center justify-center h-12 w-full mt-6 font-semibold text-sm text-white bg-blue rounded-lg active:opacity-60 hover:opacity-80 transition-all'
            onClick={confirmOtpCode}>
            {loading && <Spinner color='white'></Spinner>}
            {!loading && "CONFERMA CODICE"}
          </button>
          {otpError && <span className='mt-4 text-red'>Codice OTP errato</span>}
        </div>
      </div>
    </div>
  );
};

export default Otp;
